import { render, staticRenderFns } from "./db-show-page.vue?vue&type=template&id=3ea489c2&"
import script from "./db-show-page.vue?vue&type=script&lang=js&"
export * from "./db-show-page.vue?vue&type=script&lang=js&"
import style0 from "./db-show-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports